import { Reducer } from 'redux';

import { SessionConfigureAction } from '../../../domains/sessionConfigure/actions.types';

import { SharedConfig } from './types';

export type SessionAction = SessionConfigureAction;

const initialState: SharedConfig = {
  vivaEngageAppName: '',
  vivaEngageDefaultClientId: '',
};

const reducer: Reducer<SharedConfig, SessionAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'SESSION.CONFIGURE':
      return action.payload.shared;
    default:
      return state;
  }
};

export default reducer;
